/** @format */

import React, { Component } from 'react';
import { Container, Grid, Segment } from 'semantic-ui-react';
import ClientMiniOverview from '../ClientMiniOverview/ClientMiniOverview';
import ClientContacts from './ClientContacts/ClientContacts';
import ClientFiscal from './ClientFiscal/ClientFiscal';
import ClientAddresses from './ClientAddresses/ClientAddresses';
import ClientRequests from './ClientRequests/ClientRequests';
import ClientToolbar from './ClientToolbar/ClientToolbar';
import ClientEdit from './ClientEdit/ClientEdit';
import ClientAddressEdit from './ClientEdit/ClientAddressEdit/ClientAddressEdit';
import { inject, observer } from 'mobx-react';
// import { getClientIdFromURL } from "../../../helpers/clientHelpers";

@inject('ClientsStore')
@observer
class Client extends Component {
  componentDidMount() {
    const { ClientsStore } = this.props;
    // let clientId = getClientIdFromURL();
    // console.log(clientId);
    // if(clientId === '') {
    //     console.log('Preso dalle props')
    //     clientId = this.props.match.params.clientId;
    // }
    let clientId = this.props.match.params.clientId;
    ClientsStore.loadCurrentClient(clientId);
  }

  componentWillUnmount = () => {
    const { ClientsStore } = this.props;
    ClientsStore.resetCurrentClient();
  };

  render() {
    return (
      <div>
        <ClientToolbar />
        <Container className="content-container">
          <Grid>
            <Grid.Row>
              <Grid.Column tablet={16} computer={2}></Grid.Column>
              <Grid.Column tablet={16} computer={12}>
                <Segment>
                  <ClientMiniOverview />
                </Segment>
                <ClientFiscal />
                <ClientContacts />
                <ClientAddresses />
                <ClientRequests />
              </Grid.Column>
              <Grid.Column tablet={16} computer={2}></Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
        <ClientAddressEdit />
        <ClientEdit />
      </div>
    );
  }
}

export default Client;
